import { render, staticRenderFns } from "./my_coaching.vue?vue&type=template&id=378324b3&"
import script from "./my_coaching.vue?vue&type=script&lang=js&"
export * from "./my_coaching.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports